export default function formatPriceWithCurrency(price, currency, localeIso, decimalPlaces = 2) {
  if (!currency || !localeIso) {
    return price;
  }
  const numberFormatter = Intl.NumberFormat(localeIso, { style: 'currency', currency: currency, minimumFractionDigits: decimalPlaces });
  const formatted = numberFormatter.format(price);
  return formatted;
}
